module.exports = __webpack_public_path__ + "static/midiagnostico-logo-white-9056fc61543144a04ec5f37e73284a6c.png";